module.exports = __webpack_public_path__ + "static/sanjose-30527c4838dbcb72e455dd51c4291d7c.jpg";